import React from "react";
import { SFStack, SFUseStyled } from "@sf-core";
import SkillPathGroup from "./skillPathGroup";
import _ from "lodash";

const { styled } = SFUseStyled();

const SkillPathContainer = styled(SFStack)(({ theme }) => ({
  paddingRight: theme.spacing(2.5),
  marginBottom: theme.spacing(1),
  height: 0,
  flex: "1 0 auto",
  overflowX: "hidden",
  ...theme.scrollable,
}));

const SkillPathList = ({
  skillPathLevelId,
  skillPaths,
  domain,
  skillPathDescriptionLines,
}) => {
  if (!Array.isArray(skillPaths)) return null;

  let activeSkillPaths = skillPaths.filter(
    (x) => x.levelId === skillPathLevelId
  );

  let upSkillSkillPaths = _.orderBy(
    activeSkillPaths.filter((x) => x.isRequired),
    "rank",
    "asc"
  );

  let refreshSkillPaths = _.orderBy(
    activeSkillPaths.filter((x) => !x.isRequired),
    "rank",
    "asc"
  );

  return (
    <SkillPathContainer spacing={6} id="course-container">
      {upSkillSkillPaths.length > 0 && (
        <SkillPathGroup
          skillPaths={upSkillSkillPaths}
          isUpSkillingGroup
          descriptionLines={skillPathDescriptionLines}
          skillPathLevelId={skillPathLevelId}
        />
      )}
      {refreshSkillPaths.length > 0 && (
        <SkillPathGroup
          skillPaths={refreshSkillPaths}
          descriptionLines={skillPathDescriptionLines}
          skillPathLevelId={skillPathLevelId}
        />
      )}
    </SkillPathContainer>
  );
};

export default SkillPathList;
